import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import BaseModal from './BaseModal';
import { FieldDescriptor } from '../../types/modal/FieldDescriptor';

export interface DeleteModalProps<T> {
  show: boolean;
  item: T;
  onClose: () => void;
  onDelete: () => void;
  fields: FieldDescriptor<T>[];
  children?: React.ReactNode;
  scrollable?: boolean;
}

const DeleteModal = <T,>({
  show,
  item,
  onClose,
  onDelete,
  fields,
  children,
  scrollable = false,
}: DeleteModalProps<T>) => {
  const renderValue = (f: FieldDescriptor<T>) => {
    const value = item[f.key];
    if (f.type === 'checkbox' && typeof value === 'boolean') {
      return value ? 'チェックあり' : 'チェックなし';
    }
    if (f.type === 'date' && typeof value === 'string') {
      return new Date(value).toLocaleDateString('ja-JP');
    }
    return String(value);
  };

  const body =
    fields && fields.length ? (
      <div className="mx-auto w-75 d-grid gap-3">
        {fields.map((f) => (
          <div key={String(f.key)}>
            {f.label}： {renderValue(f)}
          </div>
        ))}
      </div>
    ) : (
      children
    );

  return (
    <BaseModal show={show} onHide={onClose} scrollable={scrollable}>
      <Modal.Header className="bg-danger text-white justify-content-center">
        <Modal.Title as="h5" className="w-100 text-center m-0">
          ⚠️ 以下の内容を本当に削除しますか？ ⚠️
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>{body}</Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={onClose}>
          キャンセル
        </Button>
        <Button variant="danger" onClick={onDelete}>
          削除
        </Button>
      </Modal.Footer>
    </BaseModal>
  );
};

export default DeleteModal;
